import axios from 'axios';
import { UserSettings } from 'oidc-client';

export async function fetchUserSettings(): Promise<UserSettings> {
  return (await axios.get<UserSettings>('/api/auth/tokens')).data;
}

export async function fetchPwdiUserSettings(): Promise<UserSettings> {
  return (await axios.get<UserSettings>('/api/auth/tokens/pwdi')).data;
}
